module.exports = __webpack_public_path__ + "img/alerts-4.6caba6f1.gif";